// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3vhaZ","label":"CategoryService_label__1235r","location":"CategoryService_location__HlUOj"};